export enum ApiOperationItems {
  COMPETITION = "competition",
  FIXTURE = "fixture",
  FIXTURE_PLAY_BY_PLAY = "fixturePlayByPlay",
  REPORT = "report",
  FIXTURE_ROSTER = "fixtureRoster",
  SEASON_ROSTER = "seasonRoster",
  LEAGUE = "league",
  CONDUCT = "conduct",
  CONFERENCE = "conference",
  DIVISION = "division",
  ENTITY = "entity",
  ENTITY_GROUP = "entityGroup",
  FINAL_STANDING = "finalStanding",
  LEADER_CRITERIA = "leaderCriteria",
  LEADER_CRITERIA_RULE = "leaderCriteriaRule",
  MATCH_PROFILE = "matchProfile",
  NOTIFICATION = "notification",
  PERMISSION_USER = "permissionUser",
  PERSON = "person",
  USER_PERMISSION = "userPermission",
  SEASON = "season",
  SEASON_POOL = "seasonPool",
  SEASON_ENTITY = "seasonEntity",
  SEASON_OFFICIAL = "seasonOfficial",
  SEASON_STAGE = "seasonStage",
  SITE = "site",
  VENUE = "venue",
  STAFF = "staff",
  STANDING = "standing",
  STANDINGS_CONFIGURATION = "standingsConfiguration",
}
